import { Component, inject, signal, TemplateRef, ViewChild } from '@angular/core';
import { AppCommonModule } from '../../../../../components/app.common.module';
import { ModalService } from '@app/components/modal/modal.service';
import { FormGroup } from '@angular/forms';
import { BrandTemplateComponent } from '../brand/brand-template/brand-template/brand-template.component';
import { SubBrandTemplateComponent } from './sub-brand-template/sub-brand-template/sub-brand-template.component';
import { environment } from '@env/environment.local';
import {
  queryParamsBrand,
  queryParamsProducts,
  queryParamsSubBrand,
} from '../financial-setup/model.models';
import { SubBrandService } from './sub-brand.service';
import { ActivatedRoute, Router } from '@angular/router';
import { BrandService } from '../brand/brand.service';
import { FinancialProductService } from '../financial-product/financial-product.service';
import { FileType } from '@app/models/fileTypes.enum';
import { BaseComponent } from '@app/components/base/base.component';
import { MenusServices } from '@app/services/menus.service';
import { NotificationService } from '@app/services/notifications.service';

@Component({
  selector: 'app-sub-brand',
  standalone: true,
  imports: [AppCommonModule, BrandTemplateComponent, SubBrandTemplateComponent],
  templateUrl: './sub-brand.component.html',
  styleUrl: './sub-brand.component.scss',
})
export class SubBrandComponent extends BaseComponent {
  @ViewChild('modalTemplate') modalTemplate!: TemplateRef<any>;
  @ViewChild('templateConfirmation') template!: TemplateRef<any>;
  form: FormGroup;
  isEdit: boolean = false;
  data: any[] = [];
  hasData: boolean = false;
  isLoading: boolean = false;
  pageSize: number = environment.pageSize;
  pageIndex: number = 1;
  total: number = 0;
  showSection: number = 1;
  selectedSubBrandData: any = null;
  selectedFile: any = null;
  subBrandId: number;
  title: string = 'Eliminar Sub Marca';
  subtitle: string = '';
  btn1: string = 'Cancelar';
  btn2: string = 'Eliminar';
  searchName: any = { placeholder: 'Buscar por nombre', value: '' };
  reset: boolean;
  searchBrand: any[] = [];
  searchCode: any = { placeholder: 'Buscar por codigo', value: '' };
  enabled: any[] = [
    { label: 'Habilitado', value: true },
    { label: 'No Habilitado', value: false },
  ];

  subBrandQuantity: number = 0;

  brandMap: Map<number, string> = new Map();

  params: queryParamsSubBrand = {
    name: null,
    subBrandCode: null,
    brandId: null,
    enabled: null,
    pageSize: this.pageSize,
    page: this.pageIndex,
  };

  paramsB: queryParamsBrand = {
    name: null,
    brandCode: null,
    enabled: null,
    pageSize: this.pageSize,
    page: this.pageIndex,
  };

  module: string = '';

  private readonly modalService = inject(ModalService);
  public readonly service = inject(SubBrandService);
  private readonly brandService = inject(BrandService);
  private readonly serviceP = inject(FinancialProductService);
  private readonly router = inject(Router);


  constructor(
    private routeActivated: ActivatedRoute,
    private menu: MenusServices,
    notification: NotificationService,
  ) {
    super(routeActivated, menu, notification);
    this.module = this.sendDataToMenu();
  }

  ngOnInit() {
    this.getList();
    this.loadBrands();
    this.initializeFilters();
  }

  isOpenModal() {
    return this.modalService.component !== null;
  }

  //#region visualizacion

  //lista general
  getList() {
    this.isLoading = true;
    this.service.getAllSubBrands(this.params).subscribe({
      next: (response) => {
        this.data = response.data;
        this.total = response.totalElements;
        this.pageIndex = response.page;
        this.hasData = response.data.length > 0;
        this.isLoading = false;
      },
      error: (error) => {
        this.isLoading = false;
      },
    });
  }

  //marcas
  loadBrands() {
    this.brandService.getAllBrands(this.paramsB).subscribe({
      next: (response: any) => {
        const brands = response.data;
        if (Array.isArray(brands)) {
          brands.forEach((brand) => {
            this.brandMap.set(brand.id, brand.name);
          });
        } else {
          console.error('Se esperaba un arreglo, pero se recibió:', brands);
        }
      },
      error: (error) => {
        console.error('Error al obtener las marcas:', error);
      },
    });
  }

  getBrandName(brandId: number): string {
    return this.brandMap.get(brandId) || 'Marca no encontrada';
  }

  //#region acciones
  selectSection(indexSection: number) {
    this.showSection = indexSection;
  }

  openModal(type: string) {
    if (type === 'edit') {
      this.modalService.component = this.modalTemplate;
    } else if (type === 'confirmation') {
      this.modalService.component = this.template;
    }
    this.modalService.openModal();
  }

  closeModal() {
    this.isEdit = false;
    this.selectedSubBrandData = null;
    this.selectedFile = null;
    this.modalService.component = null;
    this.modalService.closeModal();
  }

  openModalConfirmation(item: any) {
    this.subBrandId = item.id;
    this.selectedSubBrandData = item;
    this.subtitle = `¿Confirma la eliminación de la Sub Marca: "${item.name}"?`;
    this.modalService.component = this.template;
    this.openModal('confirmation');
  }

  create() {
    this.isEdit = false;
    this.selectedSubBrandData = null;
    this.modalService.component = this.modalTemplate;
    this.modalService.openModal();
  }

  edit(item: any, file: any) {
    this.selectedSubBrandData = item;
    this.selectedFile = file;
    this.isEdit = true;
    this.openModal('edit');
  }

  onSaveBrand(newBrand: any) {
    this.data.push(newBrand);
    this.closeModal();
    setTimeout(() => {
      this.getList();
    }, 500);
  }

  updateBrand(updatedBrand: any) {
    this.closeModal();
    setTimeout(() => {
      this.getList();
    }, 500);
  }

  deletesubBrandById(): void {
    this.isLoading = true;

    // Si availableToDelete es true, significa que no tiene modelos ni cotizaciones, hacer hard delete
    // Si es false, hacer soft delete (deshabilitar)
    const deleteMethod = this.selectedSubBrandData?.availableToDelete === true
      ? this.service.hardDeleteSubBrand(this.subBrandId)
      : this.service.deleteSubBrand(this.subBrandId);

    deleteMethod.subscribe({
      next: () => {
        this.closeModal();
        this.isLoading = false;
        this.getList();
      },
      error: (error) => {
        this.isLoading = false;
        const msg = error?.error?.errors?.[0] || error?.message || 'Error al eliminar la sub marca.';
        this.showNotificationError(msg);
      },
    });
  }

  handlePage(e: any) {
    this.params.page = e.pageIndex + 1;
    this.params.pageSize = e.pageSize;
    this.getList();
  }

  goProducts(subBrandId: number) {
    this.router.navigate(['financial-product/list'], {
      queryParams: { subBrandId: subBrandId },
    });
  }

  goBrand() {
    this.router.navigate([`catalogs/brand`]);
  }

  filter(value: any, typeField: string) {
    switch (typeField) {
      case 'name':
        this.params.name = value;
        break;
      case 'brandId':
        this.params.brandId = value;
        break;
      case 'subBrandCode':
        this.params.subBrandCode = value;
        break;
      case 'enabled':
        this.params.enabled = value;
        break;
      case 'default':
        break;
    }
  }

  search() {
    this.params.page = 1;
    this.getList();
  }

  resetFilters() {
    // Resetear parámetros de búsqueda
    this.params = {
      name: null,
      subBrandCode: null,
      brandId: null,
      enabled: null,
      pageSize: this.pageSize,
      page: 1,
    };

    // Resetear estado visual de los filtros
    this.searchName = { placeholder: 'Buscar por nombre', value: '' };
    this.searchCode = { placeholder: 'Buscar por codigo', value: '' };

    // Activar señal de reset para los componentes de filtro
    this.reset = true;

    // Resetear la señal después de un breve delay para que los componentes la detecten
    setTimeout(() => {
      this.reset = false;
    }, 100);

    this.pageIndex = 1;
    this.getList();
  }

  initializeFilters() {
    this.serviceP.getBrand().subscribe({
      next: (response) => {
        this.searchBrand = response.data.map((brand: any) => {
          return { label: brand.brand, value: brand.id };
        });
      },
    });
  }
}
